import { useCurrency } from "@/context/CurrencyContext";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { CalendarDays } from "lucide-react";

const TR_MONTHS = ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"];

const buildOptions = () => {
  const now = new Date();
  const opts = [];
  for (let i = -6; i < 24; i++) {
    const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
    const value = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
    opts.push({ value, label: `${TR_MONTHS[d.getMonth()]} ${d.getFullYear()}` });
  }
  return opts;
};

export const MonthFilter = () => {
  const { month, setMonth } = useCurrency();
  return (
    <Select value={month} onValueChange={setMonth}>
      <SelectTrigger data-testid="month-filter-select" className="w-44 h-9 bg-[#131924] border-white/10 text-sm">
        <CalendarDays className="w-4 h-4 mr-1 text-indigo-400" />
        <SelectValue />
      </SelectTrigger>
      <SelectContent className="bg-[#131924] border-white/10 text-slate-100 max-h-72">
        <SelectItem value="all" data-testid="month-filter-all">Tüm Zamanlar</SelectItem>
        {buildOptions().map((o) => (
          <SelectItem key={o.value} value={o.value} data-testid={`month-filter-${o.value}`}>{o.label}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export const monthLabel = (month) => {
  if (!month || month === "all") return "Tüm Zamanlar";
  const [y, m] = month.split("-");
  return `${TR_MONTHS[Number(m) - 1]} ${y}`;
};
